import React from 'react';
import { motion } from 'framer-motion';
export function ClosingBlock() {
  return <section id="closing" className="w-full scroll-mt-20 bg-ink px-5 py-8 sm:py-16" data-id="element-60" data-mp="2fp3ggjfih1kl">
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.4
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-61" data-mp="2apqstwgtfqgy">
        <h2 className="font-serif-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-62" data-mp="20suidl7cwu9r">
          Tutto il sistema. Un solo accesso.
        </h2>
        
        <div className="mt-6 flex flex-col gap-2 text-[15px] font-medium text-white/90 sm:mt-8 sm:text-lg" data-id="element-63" data-mp="1s0aosz5x9fvs">
          <p data-id="element-64" data-mp="1n1fvv4e8qaxy">5 volumi completi + 4 bonus professionali</p>
          <p data-id="element-65" data-mp="1i0s76pdhi66w">504 pagine interamente in italiano</p>
          <p className="text-cobalt" data-id="element-66" data-mp="1i0jxf6cnrgzx">Teoria visiva · Attività · Laboratori · Verifiche · Soluzioni</p>
          <p className="mt-2 text-sm text-white/60" data-id="element-67" data-mp="1d2ia29878vin">Pagamento unico: 19 €</p>
        </div>

        <div className="mt-8 flex flex-col items-center sm:mt-10" data-id="element-68" data-mp="3nrv5xz8ikc1n">
          <span className="text-sm font-medium text-white/60 sm:text-base" data-id="element-69" data-mp="3skeiqtzdn35e">Pagamento unico</span>
          <span className="font-serif-display text-[52px] font-bold leading-none text-cobalt sm:text-7xl" data-id="element-70" data-mp="3dvs1unu3q3c2">
            19 €
          </span>
        </div>

        <motion.a href="#get-access" animate={{
        y: [0, -2, 0],
        scale: [1, 1.015, 1]
      }} whileHover={{
        scale: 1.025,
        boxShadow: '0 16px 34px -10px rgba(22, 163, 74, 0.7)'
      }} whileTap={{
        scale: 0.98
      }} transition={{
        y: {
          duration: 2.2,
          ease: 'easeInOut',
          repeat: Infinity
        },
        scale: {
          duration: 2.2,
          ease: 'easeInOut',
          repeat: Infinity
        },
        type: 'spring',
        stiffness: 400,
        damping: 22
      }} className="mt-7 flex min-h-[54px] w-full max-w-md items-center justify-center gap-2 rounded-[10px] bg-cta-green px-6 py-4 text-base font-extrabold tracking-tight text-white shadow-lg shadow-cta-green/40 sm:mt-9 sm:min-h-[58px] sm:text-lg" data-id="element-71" data-mp="3is8tvt4f91uf">
          OTTIENI CHIMICA VISIVA™ ORA
        </motion.a>
        <p className="mt-3 text-[11px] text-white/60 sm:text-xs" data-id="element-72" data-mp="mx5jcqu1spd7">
          19 € · Pagamento unico · Nessun abbonamento
        </p>
        <p className="mt-1.5 text-[11px] text-white/50 sm:text-xs" data-id="element-73" data-mp="hyu9wh7o0gvi">
          Accesso immediato · Garanzia di 7 giorni
        </p>
      </motion.div>
    </section>;
}